import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  IconButton,
  Typography,
  Box,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormLabel,
  Chip,
  MenuItem,
  Select,
  InputLabel,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import ImportExportIcon from "@material-ui/icons/ImportExport";
import CloseIcon from "@material-ui/icons/Close";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { apiPath } from "api";
import { generalAuthTokenHeader } from "__helpers/auth-header";
import { userService } from "_services/user.service";
import { format } from 'date-fns';
import { Alert, AlertTitle } from "@material-ui/lab";

class ContactDialog extends React.Component {
  constructor(props) {
    super(props);

    const patientId = JSON.parse(localStorage.getItem("_selected_patient_list"));
    console.log("_selected_patient_list", patientId);
    const userinfo = JSON.parse(localStorage.getItem("_user_info")) || {};

    this.state = {
      openContactDialog: false,
      openNewContactDialog: false,
      openEditContactDialog: false,
      editContact: null,
      contactName: "",
      email: "",
      mobilePhone: "",
      homePhone: "",
      relationship: "",
      patientId: patientId,
      dischargePlannerId: userinfo.dischargePlanner.id,
      isPrimary: false,
      contactList: [],
      selectedType: '', // Initialize selectedType in state
      open: false,
      onClose: false,
      inviteLoading: false,
      confirmAction: null,
      openConfirmDialog: false,
    };
  }
  componentDidMount() {
    console.log("ContactDialog mounted. Open status:", this.props.open);
  }
  handleTypeChange = (e) => {
    this.setState({ selectedType: e.target.value }); // Update state on change
  };

  handleOpenContactDialog = async () => {
    try {
      await this.fetchContactList();
    } catch (err) {
      console.error("Error in fetchContactList:", err);
      // Optionally show a notification or fallback here
    }
    this.setState({ openContactDialog: true });
  };


  handleCloseContactDialog = () => {
    this.setState({ openContactDialog: false });
  };

  handleOpenNewContactDialog = () => {
    this.setState({
      openNewContactDialog: true,
      contactName: '',
      mobilePhone: '',
      homePhone: '',
      email: '',

      relationship: '',

    });
  };


  handleCloseNewContactDialog = () => {
    this.setState({ openNewContactDialog: false });
  };

  fetchImportContact = async () => {
    let showNotification = {};
    const apiUrl = apiPath.GetImportPccPatientContacts + "?patientId=" + this.props.patientId + "&dpId=" + this.state.dischargePlannerId;

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });

      if (response.status === 401) {
        userService.logout();
        window.location.reload(true);
        return;
      }

      if (response.status === 400) {
        showNotification = { title: "Import", message: "Bad Request", type: "danger" };
      } else {
        const data = await response.json();
        const messageText = data.message || "Import successful";

        if (messageText === "No contact data found.") {
          showNotification = { title: "Import", message: messageText, type: "warning" };
        } else {
          showNotification = { title: "Import", message: messageText, type: "success" };
          await this.fetchContactList();
        }
      }

      if (showNotification.title) userService.showNotification(showNotification);
    } catch (error) {
      console.error("Error importing contacts", error);
      userService.showNotification({
        title: "Import",
        message: "Server Error",
        type: "danger",
      });
    }
  };

  handleOpenEditContactDialog = async (contact) => {
    console.log(contact.patientContactId)
    const payload = {
      patientContactId: contact.patientContactId,
      dpId: this.state.dischargePlannerId,
      isPccPatientContact: contact.isPccPatientContact,
    };
    const apiUrl = apiPath.GetPatientContactById;

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          ...generalAuthTokenHeader(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        const data = await response.json();

        this.setState({
          openEditContactDialog: true,
          editContact: data,
          contactName: data.contactName,
          email: data.email || "",
          mobilePhone: data.mobilePhone,
          homePhone: data.homePhone,
          relationship: data.relationship,
          isPrimary: data.isPrimary,
          isPccPatientContact: data.isPccPatientContact,
        });
      } else {
        const errorData = await response.json();
        console.error("Failed to fetch contact by ID:", errorData);
        userService.showNotification({
          title: "Contact",
          message: "Failed to fetch contact details.",
          type: "danger",
        });
      }
    } catch (error) {
      console.error("Error fetching contact by ID:", error);
      userService.showNotification({
        title: "Contact",
        message: "Error while fetching contact details.",
        type: "danger",
      });
    }
  };


  formatDateToServerFormat = (date) => {
    return date ? format(new Date(date), 'yyyy-MM-dd') : null;
  };

  handleCloseEditContactDialog = () => {
    this.setState({ openEditContactDialog: false, editContact: null });
  };



  handleAddContact = async () => {
    const {
      contactName,
      mobilePhone,
      homePhone,
      email,
      isPrimary,
      relationship,
    } = this.state;

    // Email validation regex
    const isValidEmail = email === "" || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    // Validate required fields
    if (!contactName || !relationship) {
      userService.showNotification({
        title: "",
        message: "Please fill all required fields.",
        type: "danger",
      });
      return; // Stop if validation fails
    }

    if (!email && !mobilePhone) {
      userService.showNotification({
        title: "",
        message: "Please fill at least Email or Mobile Phone.",
        type: "danger",
      });
      return;
    }
    // if (isPrimary && this.state.contactList.some(c => c.isPrimary)) {
    //   userService.showNotification({
    //     title: "Primary Contact",
    //     message: "A primary contact already exists. Only one primary contact is allowed.",
    //     type: "warning",
    //   });
    //   return;
    // }
    if (!isValidEmail) {
      userService.showNotification({
        title: "",
        message: "Please enter a valid email address.",
        type: "danger",
      });
      return;
    }
    const patientId = JSON.parse(localStorage.getItem("_selected_patient_list")); // ← Get from localStorage

    const payload = {
      name: contactName,
      mobilePhone,
      homePhone,
      email,
      isPrimary,
      relationship,
      dpId: this.state.dischargePlannerId,
      patientId: this.props.patientId,
    };

    console.log("payload", payload);

    const apiUrl = apiPath.AddPatientContactSave;
    let showNotification = {};


    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          ...generalAuthTokenHeader(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.status === 400) {
        showNotification = { title: "Survey", message: "Bad Request", type: "danger" };
      } else if (response.status === 401) {
        userService.logout();
        window.location.reload(true);
      } else if (!response.ok) {
        showNotification = { title: "Survey", message: "Error submitting contact", type: "danger" };
      } else {
        showNotification = {
          title: "Contact",
          message: "Contact added successfully!",
          type: "success",
        };

        this.setState({ openNewContactDialog: false });
        if (this.props.onUpdate) {
          console.log("Calling parent onUpdate to reload contact list...");
          this.props.onUpdate();
          console.log("Parent onUpdate finished.");
        }

        // Refresh contact list if needed

      }

      if (showNotification.title) userService.showNotification(showNotification);
    } catch (error) {
      console.error("Error submitting contact", error);
      userService.showNotification({ title: "Contact", message: "Server Error", type: "danger" });
    }


  };

  handleUpdateContact = async () => {
    const {
      contactName,
      mobilePhone,
      homePhone,
      email,
      isPrimary,
      relationship,
      editContact, // This contains patientContactId
    } = this.state;
    // Email validation regex
    const isValidEmail = email === "" || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    // Validate required fields
    if (!contactName || !relationship) {
      userService.showNotification({
        title: "",
        message: "Please fill all required fields.",
        type: "danger",
      });
      return; // Stop if validation fails
    }

    if (!email && !mobilePhone) {
      userService.showNotification({
        title: "",
        message: "Please fill at least Email or Mobile Phone.",
        type: "danger",
      });
      return;
    }

    // if (
    //   isPrimary &&
    //   this.state.contactList.some(
    //     (c) => c.isPrimary && c.patientContactId !== this.state.editContact.patientContactId
    //   )
    // ) {
    //   userService.showNotification({
    //     title: "Primary Contact",
    //     message: "A primary contact already exists. Only one primary contact is allowed.",
    //     type: "warning",
    //   });
    //   return;
    // }


    if (!isValidEmail) {
      userService.showNotification({
        title: "",
        message: "Please enter a valid email address.",
        type: "danger",
      });
      return;
    }

    const patientId = JSON.parse(localStorage.getItem("_selected_patient_list")); // ← Get from localStorage

    const payload = {
      contactName,
      mobilePhone,
      homePhone,
      email,

      relationship,
      dpId: this.state.dischargePlannerId,
      patientId: this.props.patientId,
      isPccPatientContact: this.state.isPccPatientContact,
      isPrimary: this.state.isPrimary
    };

    console.log("payload", payload);
    const apiUrl = `${apiPath.UpdatePatientContact}/${editContact.patientContactId}`;

    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          ...generalAuthTokenHeader(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (response.ok) {
        userService.showNotification({
          title: "Contact",
          message: "Contact updated successfully.",
          type: "success",
        });

        // Optionally refresh the contact list or close modal here
        if (this.props.onUpdate) {
          console.log("Calling parent onUpdate to reload contact list...");
          this.props.onUpdate();
          console.log("Parent onUpdate finished.");
        }

        this.setState({ openEditContactDialog: false, editContact: null });
      } else {
        console.error("Update failed:", result);
        userService.showNotification({
          title: "Contact",
          message: result.message || "Failed to update contact.",
          type: "danger",
        });
      }
    } catch (error) {
      console.error("Error updating contact:", error);
      userService.showNotification({
        title: "Contact",
        message: "Error while updating contact.",
        type: "danger",
      });
    }
  };

  async fetchContactList() {
    let showNotification = {};
    const patientId = JSON.parse(localStorage.getItem("_selected_patient_list"));
    console.log("patientId in  fetchContactList", patientId);

    const apiUrl = apiPath.GetAllPatientContactList + "?patientId=" + this.props.patientId + "&dpId=" + this.state.dischargePlannerId;

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });

      if (response.status === 400) {
        showNotification = { title: "contact List", message: "Bad Request", type: "danger" };
      } else if (response.status === 401) {
        userService.logout();
        window.location.reload(true);
      } else if (!response.ok) {
        showNotification = { title: "contact List", message: "Error fetching data", type: "danger" };
      }

      const data = await response.json();
      console.log("contactList Fetched: ", data);

      // Preserve order based on previous state if available
      const oldOrder = this.state.contactList.map(c => c.patientContactId);
      const sortedData = oldOrder.length
        ? oldOrder.map(id => data.find(c => c.patientContactId === id)).filter(Boolean)
        : data;
      console.log("contactList Fetched: ", sortedData);
      this.setState({ contactList: data });

      if (showNotification.title) userService.showNotification(showNotification);
    } catch (error) {
      console.error("Error fetching input types", error);
      showNotification = { title: "contact List", message: "Server Error", type: "danger" };
      userService.showNotification(showNotification);
    }
  }

  openConfirmationDialog = (type, contact) => {
    this.setState({
      confirmAction: { type, contact },
      openConfirmDialog: true,
    });
  };

  handleConfirmAction = async () => {
    const { confirmAction } = this.state;
    if (!confirmAction) return;

    this.setState({ openConfirmDialog: false });

    if (confirmAction.type === "invite") {
      await this.handleInviteAsConsumer(confirmAction.contact);
    } else if (confirmAction.type === "deactivate") {
      await this.handleDeactivateConsumer(confirmAction.contact);
    } else if (confirmAction.type === "reactivate") {
      await this.handleReactivateConsumer(confirmAction.contact);
    }

    this.setState({ confirmAction: null });
  };

  handleInviteAsConsumer = async (contact) => {
    this.setState({ inviteLoading: true });

    const payload = {
      patientId: this.props.patientId,
      contactId: contact.patientContactId,
      isPccContact: contact.isPccPatientContact || false,
      invitedBy: this.state.dischargePlannerId,
    };

    try {
      const response = await fetch(apiPath.CreatePatientConsumer, {
        method: "POST",
        headers: generalAuthTokenHeader(),
        body: JSON.stringify(payload),
      });

      if (response.status === 201 || response.ok) {
        userService.showNotification({
          title: "Patient Consumer",
          message: `${contact.contactName} has been invited as a patient consumer.`,
          type: "success",
        });
        if (this.props.onUpdate) {
          this.props.onUpdate();
        }
      } else if (response.status === 401) {
        userService.logout();
        window.location.reload(true);
      } else {
        userService.showNotification({
          title: "Patient Consumer",
          message: "Failed to invite contact as patient consumer.",
          type: "danger",
        });
      }
    } catch (error) {
      console.error("Error inviting patient consumer:", error);
      userService.showNotification({
        title: "Patient Consumer",
        message: "Server error while inviting patient consumer.",
        type: "danger",
      });
    }

    this.setState({ inviteLoading: false });
  };

  handleDeactivateConsumer = async (contact) => {
    const apiUrl = `${apiPath.DeactivatePatientConsumer}/${contact.patientConsumerId}/deactivate?deactivatedBy=${this.state.dischargePlannerId}`;

    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: generalAuthTokenHeader(),
      });

      if (response.ok) {
        userService.showNotification({
          title: "Patient Consumer",
          message: `Consumer access deactivated for ${contact.contactName}.`,
          type: "success",
        });
        if (this.props.onUpdate) {
          this.props.onUpdate();
        }
      } else if (response.status === 401) {
        userService.logout();
        window.location.reload(true);
      } else {
        userService.showNotification({
          title: "Patient Consumer",
          message: "Failed to deactivate patient consumer.",
          type: "danger",
        });
      }
    } catch (error) {
      console.error("Error deactivating patient consumer:", error);
      userService.showNotification({
        title: "Patient Consumer",
        message: "Server error while deactivating patient consumer.",
        type: "danger",
      });
    }
  };

  handleReactivateConsumer = async (contact) => {
    const apiUrl = `${apiPath.ReactivatePatientConsumer}/${contact.patientConsumerId}/reactivate`;

    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: generalAuthTokenHeader(),
      });

      if (response.ok) {
        userService.showNotification({
          title: "Patient Consumer",
          message: `Consumer access reactivated for ${contact.contactName}.`,
          type: "success",
        });
        if (this.props.onUpdate) {
          this.props.onUpdate();
        }
      } else if (response.status === 401) {
        userService.logout();
        window.location.reload(true);
      } else {
        userService.showNotification({
          title: "Patient Consumer",
          message: "Failed to reactivate patient consumer.",
          type: "danger",
        });
      }
    } catch (error) {
      console.error("Error reactivating patient consumer:", error);
      userService.showNotification({
        title: "Patient Consumer",
        message: "Server error while reactivating patient consumer.",
        type: "danger",
      });
    }
  };

  render() {
   const { open, onClose } = this.props;
    const contactList = this.state.contactList.length > 0
      ? this.state.contactList
      : this.props.contactList;
    return (
      <div style={{ marginLeft: 10}}>
        {/* <Box display="flex" marginRight={1}>
          <Button className="pointer btn1 borderradius2" onClick={this.handleOpenContactDialog} style={{ borderRadius: "0px 20px 20px 0px !important" }}>
            Contact
          </Button>
        </Box> */}
        {/* Main Contact Dialog */}
         <Dialog open={open}  onClose={onClose} fullWidth maxWidth="md">
          <DialogTitle>
            Contacts
            <Box component="p" style={{ fontSize: "12px", color: "#666", margin: "4px 0 0 0", fontWeight: "normal" }}>
              Only imported contacts with at least one of email, cell phone, or home phone are displayed.
            </Box>
            <Box display="flex" justifyContent="flex-end" position="absolute" right={16} top={8}>
              <Button
                startIcon={<ImportExportIcon />}
                size="small"
                style={{ marginRight: 8 }}
                onClick={this.fetchImportContact}
              >
                Import Contact
              </Button>
              <Button
                startIcon={<AddIcon />}
                color="primary"
                variant="contained"
                size="small"
                onClick={this.handleOpenNewContactDialog}
              >
                New Contact
              </Button>
            </Box>
          </DialogTitle>
          <DialogContent>
            {contactList?.length === 0 ? (
              <Typography variant="body1" align="center" color="textSecondary">
                No contacts found.
              </Typography>
            ) : (
              contactList?.map((contact) => (
                <Box key={contact.pccContactListId || contact.patientContactId} borderBottom={1} mb={2} pb={1}>
                  <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                    <Box flex={1}>
                      <Box display="flex" alignItems="center">
                        <Typography variant="subtitle1">
                          {contact.contactName} - {contact.relationship}
                        </Typography>
                        {contact.isPrimary && (
                          <Chip
                            size="small"
                            label="Primary"
                            color="primary"
                            style={{ marginLeft: 8 }}
                          />
                        )}
                        {contact.isPatientConsumer && (
                          <Chip
                            size="small"
                            label={contact.consumerStatus}
                            style={{
                              marginLeft: 8,
                              backgroundColor: contact.consumerStatus === "ACTIVE" ? "#4caf50"
                                : contact.consumerStatus === "INVITED" ? "#ff9800"
                                : "#9e9e9e",
                              color: "#fff",
                            }}
                          />
                        )}
                        {contact.isPccPatientContact && (
                          <Chip
                            size="small"
                            label="Imported"
                            style={{
                              marginLeft: 8,
                              backgroundColor: "#1976d2",
                              color: "#fff",
                            }}
                          />
                        )}
                        {contact.removedFromPcc && (
                          <Chip
                            size="small"
                            label="Removed from PCC"
                            style={{
                              marginLeft: 8,
                              backgroundColor: "#d32f2f",
                              color: "#fff",
                            }}
                          />
                        )}
                      </Box>

                      {/* Contact details */}
                      <Box mt={1}>
                        {[
                          { label: "Mobile:", value: contact.mobilePhone || "N/A" },
                          { label: "Home:", value: contact.homePhone || "N/A" },
                          { label: "Email:", value: contact.email || "N/A" },
                          {
                            label: "Type:", value: contact.contactType?.length > 0
                              ? contact.contactType.map((t) => t.contactType).join(", ")
                              : "N/A"
                          },
                        ].map((item, idx) => (
                          <Box key={idx} display="flex" alignItems="center" mb={0.5}>
                            <Typography
                              variant="body2"
                              style={{ width: 60, fontWeight: 500 }} // fixed width for alignment
                            >
                              {item.label}
                            </Typography>
                            <Typography variant="body2">{item.value}</Typography>
                          </Box>
                        ))}
                      </Box>


                    </Box>

                    <Box display="flex" alignItems="center">
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => this.handleOpenEditContactDialog({
                          ...contact,
                          patientContactId: contact.patientContactId
                        })}
                        style={{ marginLeft: 16 }}
                      >
                        Edit
                      </Button>
                       {/* Temporarily commented out — consumer invite flow disabled 
                      {!contact.isPatientConsumer && (contact.email || contact.mobilePhone) && (
                        <Button
                          size="small"
                          variant="outlined"
                          color="primary"
                          startIcon={<PersonAddIcon />}
                          onClick={() => this.openConfirmationDialog("invite", contact)}
                          style={{ marginLeft: 8 }}
                          disabled={this.state.inviteLoading}
                        >
                          Invite
                        </Button>
                      )}

                      {contact.isPatientConsumer && contact.consumerStatus === "ACTIVE" && (
                        <Button
                          size="small"
                          variant="outlined"
                          color="secondary"
                          onClick={() => this.openConfirmationDialog("deactivate", contact)}
                          style={{ marginLeft: 8 }}
                        >
                          Deactivate
                        </Button>
                      )}

                      {contact.isPatientConsumer && contact.consumerStatus === "DEACTIVATED" && (
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() => this.openConfirmationDialog("reactivate", contact)}
                          style={{ marginLeft: 8 }}
                        >
                          Reactivate
                        </Button>
                      )} */}
                    </Box>
                  </Box>
                </Box>
              ))
            )}
          </DialogContent>

          <DialogActions>
            <Button onClick={onClose} color="secondary">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* New Contact Dialog */}
        <Dialog open={this.state.openNewContactDialog} onClose={this.handleCloseNewContactDialog} fullWidth maxWidth="sm">
          <DialogTitle>
            Add New Contact
            <IconButton
              aria-label="close"
              onClick={this.handleCloseNewContactDialog}
              style={{ position: "absolute", right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <TextField
              margin="dense"
              label="Name"
              name="contactName"
              InputLabelProps={{ className: "required-label" }}
              fullWidth
              value={this.state.contactName}
              onChange={(e) => this.setState({ contactName: e.target.value })}
            />
            <TextField
              margin="dense"
              label="Email"
              name="email"
              type="email"
              InputLabelProps={{ className: "required-label" }}
              fullWidth
              value={this.state.email}
              error={this.state.email !== "" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.email)}
              helperText={
                this.state.email !== "" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.email)
                  ? "Invalid email format"
                  : ""
              }
              onChange={(e) => this.setState({ email: e.target.value })}
            />
            {/* OR label between fields */}
            <div
              style={{
                textAlign: "left",
                marginTop: "5px",   // smaller space above OR
                marginBottom: "0px", // no extra space below OR
                marginLeft: "10px",
                fontWeight: "bold",
                fontSize: "10px"
              }}
            >
              OR
            </div>


            <TextField
              margin="dense"
              label="Mobile Phone"
              name="mobilePhone"
              InputLabelProps={{ className: "required-label" }}
              fullWidth
              value={this.state.mobilePhone}
              onChange={(e) => {
                const input = e.target.value;
                // Allow digits, space, parentheses, hyphens only
                const formatted = input.replace(/[^\d()\-\s]/g, "");
                this.setState({ mobilePhone: formatted });
              }}

              style={{
                marginTop:
                  this.state.mobilePhone !== "" ||
                    document.activeElement.name === "mobilePhone"
                    ? "8px" // when focused or filled
                    : "0.3px"  // default reduced margin
              }}

            />
            <TextField
              margin="dense"
              label="Home Phone"
              name="homePhone"
              fullWidth
              value={this.state.homePhone}
              onChange={(e) => {
                const input = e.target.value;
                // Allow digits, space, parentheses, hyphens only
                const formatted = input.replace(/[^\d()\-\s]/g, "");
                this.setState({ homePhone: formatted });
              }}
            />
            <TextField
              margin="dense"
              label="Relationship"
              name="relationship"
              InputLabelProps={{ className: "required-label" }}
              fullWidth
              value={this.state.relationship}
              onChange={(e) => this.setState({ relationship: e.target.value })}
            />
            <FormControl component="fieldset" style={{ marginTop: 12 }}>
              <FormLabel component="legend">Set as Primary</FormLabel>
              <RadioGroup
                row
                value={this.state.isPrimary ? "yes" : "no"}
                onChange={(e) => this.setState({ isPrimary: e.target.value === "yes" })}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>

            {/* <Box mt={2}>
              <FormControl fullWidth>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    label=""
                    value={this.state.}
                    onChange={this.handleDate}
                    KeyboardButtonProps={{ "aria-label": "change date" }}
                  />
                </MuiPickersUtilsProvider>
              </FormControl>
            </Box> */}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseNewContactDialog} color="secondary">
              Cancel
            </Button>
            <Button color="primary" variant="contained" onClick={this.handleAddContact}>
              Add
            </Button>
          </DialogActions>
        </Dialog>

        {/* Edit Contact Dialog */}
        <Dialog open={this.state.openEditContactDialog} onClose={this.handleCloseEditContactDialog} fullWidth maxWidth="sm">
          <DialogTitle>
            Edit Contact
            <IconButton
              aria-label="close"
              onClick={this.handleCloseEditContactDialog}
              style={{ position: "absolute", right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            {/* Existing form fields... */}

            {this.state.isPccPatientContact && (
              <Alert severity="info" style={{ marginTop: 7 }}>
                <AlertTitle>Note</AlertTitle>
                This is only being updated in MaxMRJ. The updated information will not be pushed to PCC.
              </Alert>
            )}
          </DialogContent>
          <DialogContent>
            <TextField
              margin="dense"
              label="Name"
              name="contactName"
              InputLabelProps={{ className: "required-label" }}
              fullWidth
              value={this.state.contactName}
              onChange={(e) => this.setState({ contactName: e.target.value })}
            />
            <TextField
              margin="dense"
              label="Email"
              name="email"
              type="email"
              InputLabelProps={{ className: "required-label" }}
              fullWidth
              value={this.state.email}
              error={this.state.email !== "" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.email)}
              helperText={
                this.state.email !== "" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.email)
                  ? "Invalid email format"
                  : ""
              }
              onChange={(e) => this.setState({ email: e.target.value })}
            />
            {/* OR label between fields */}
            <div
              style={{
                textAlign: "left",
                marginTop: "5px",   // smaller space above OR
                marginBottom: "0px", // no extra space below OR
                marginLeft: "10px",
                fontWeight: "bold",
                fontSize: "10px"
              }}
            >
              OR
            </div>


            <TextField
              margin="dense"
              label="Phone Number"
              name="mobilePhone"
              InputLabelProps={{ className: "required-label" }}
              fullWidth
              value={this.state.mobilePhone}
              onChange={(e) => {
                const input = e.target.value;
                // Allow digits, space, parentheses, hyphens only
                const formatted = input.replace(/[^\d()\-\s]/g, "");
                this.setState({ mobilePhone: formatted });
              }}

              style={{
                marginTop:
                  this.state.mobilePhone !== "" ||
                    document.activeElement.name === "mobilePhone"
                    ? "8px" // when focused or filled
                    : "0.3px"  // default reduced margin
              }}
            />
            <TextField
              margin="dense"
              label="Home Phone"
              name="homePhone"
              fullWidth
              value={this.state.homePhone}
              onChange={(e) => {
                const input = e.target.value;
                // Allow digits, space, parentheses, hyphens only
                const formatted = input.replace(/[^\d()\-\s]/g, "");
                this.setState({ homePhone: formatted });
              }}
            />
            <TextField
              margin="dense"
              label="Relationship"
              name="relationship"
              InputLabelProps={{ className: "required-label" }}
              fullWidth
              value={this.state.relationship}
              onChange={(e) => this.setState({ relationship: e.target.value })}
            />
            <FormControl component="fieldset" style={{ marginTop: 12 }}>
              <FormLabel component="legend">Set as Primary</FormLabel>
              <RadioGroup
                row
                value={this.state.isPrimary ? "yes" : "no"}
                onChange={(e) => this.setState({ isPrimary: e.target.value === "yes" })}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
            {/* <Box mt={2}>
              <FormControl fullWidth>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    label=""
                    value={this.state.}
                    onChange={this.handleDate}
                    KeyboardButtonProps={{ "aria-label": "change date" }}
                  />
                </MuiPickersUtilsProvider>
              </FormControl>
            </Box> */}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseEditContactDialog} color="secondary">
              Cancel
            </Button>
            <Button color="primary" variant="contained" onClick={this.handleUpdateContact}>
              Update
            </Button>
          </DialogActions>
        </Dialog>

        {/* Confirmation Dialog for Patient Consumer Actions */}
        <Dialog
          open={this.state.openConfirmDialog}
          onClose={() => this.setState({ openConfirmDialog: false })}
          maxWidth="xs"
        >
          <DialogTitle>Confirm Action</DialogTitle>
          <DialogContent>
            <Typography>
              {this.state.confirmAction?.type === "invite" &&
                `Invite ${this.state.confirmAction.contact.contactName} as a Patient Consumer? An OTP will be sent to their phone/email.`}
              {this.state.confirmAction?.type === "deactivate" &&
                `Deactivate consumer access for ${this.state.confirmAction.contact.contactName}? They will no longer be able to view patient information.`}
              {this.state.confirmAction?.type === "reactivate" &&
                `Reactivate consumer access for ${this.state.confirmAction.contact.contactName}?`}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => this.setState({ openConfirmDialog: false })}
              color="secondary"
            >
              Cancel
            </Button>
            <Button
              onClick={this.handleConfirmAction}
              color="primary"
              variant="contained"
              disabled={this.state.inviteLoading}
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default ContactDialog;
